<form [formGroup]="form">
  <div class="p-fluid grid">
    <div class="field col-6 d-flex flex-column">
      <label for="datainicio">Período de Pagamento(Início)</label>
      <p-datepicker appendTo="body" class="d-contents" id="datainicio" formControlName="datainicio"
        [showIcon]="true" dateFormat="mm/yy" view="month" placeholder="Seleccione o mês/ano"></p-datepicker>
    </div>

    <div class="field col-6 d-flex flex-column">
      <label for="datafim">Período de Pagamento(Fim)</label>
      <p-datepicker appendTo="body" class="d-contents" id="datafim" view="month" formControlName="datafim"
        [showIcon]="true" dateFormat="mm/yy" placeholder="Seleccione o mês/ano"></p-datepicker>
      <div *ngIf="form.hasError('dataInicioFimRange')" class="error-message">
        Data de término não pode ser anterior à data de início
      </div>
    </div>

    <div class="field col-6 d-flex flex-column">
      <label for="periodicidade">Periodicidade</label>
      <p-select [filter]="true" [showClear]="true" appendTo="body" id="periodicidade" formControlName="periodicidade"
        [options]="periods" optionLabel="label" optionValue="time" placeholder="Seleccione a periodicidade"
        class="w-full"></p-select>
    </div>

    <div class="field col-6 d-flex flex-column">
      <label for="nivelAcademico">Nível Académico</label>
      <p-select [filter]="true" [showClear]="true" appendTo="body" id="nivelAcademico" formControlName="nivelAcademico"
        [options]="nivelAcademicoOptions" optionLabel="label" optionValue="id"
        placeholder="Seleccione o nível académico" class="w-full"></p-select>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="instituicao">Instituição de Ensino</label>
      <p-select id="instituicao" appendTo="body" [filter]="true" [options]="InstEnsino" optionLabel="nome"
        optionValue="id" placeholder="Seleccione a instituição" formControlName="instituicao" class="w-full">
      </p-select>
      <small *ngIf="form.get('instituicao')?.touched && form.get('instituicao')?.invalid" class="error-message">
        Instituição é obrigatória.
      </small>
    </div>

    <div class="field col-12 d-flex flex-column">
      <label for="estudanteID">Estudante</label>
      <p-select [filter]="true" [showClear]="true" appendTo="body" id="estudanteID" formControlName="estudanteID"
        [options]="Estudantes" optionLabel="nome" optionValue="id" placeholder="Seleccione o estudante" class="w-full"
        [disabled]="!form.get('instituicao')?.value">
      </p-select>
      <div *ngIf="form.get('estudanteID')?.touched && form.get('estudanteID')?.invalid">
        <small *ngIf="form.get('estudanteID')?.errors?.['required']" class="error-message">
          Estudante é obrigatório.
        </small>
      </div>
    </div>

    <div class="field col-12 d-flex flex-column gap-2" *ngIf="form.get('estudanteID')?.value">
      <ng-container *ngIf="pagination.data?.length; else emptyTemplate">
        <span>Tipo de Bolsa: <strong>{{ bolsa?.tipoBolsaDescricao }}</strong></span>
        <span>Instituição Gestora: <strong>{{ bolsa?.instituicaoGestora?.nome }}</strong></span>
        <span>Área de Conhecimento: <strong>{{ bolsa?.areaProgramaFormacao?.areaFormacao?.designacao }}</strong></span>
        <span *ngIf="valorRegra != null">Valor (Bolsa): <strong>{{ valorRegra }}</strong></span>
        <span *ngIf="f['moeda']?.value">Moeda: <strong>{{ f['moeda']?.value }}</strong></span>
      </ng-container>
      <ng-template #emptyTemplate>
        <div class="no-data">
          <app-data-void titulo="Nenhum auxílio de Formação encontrado"
            descricao="Clique em adicionar auxílio para criar uma."></app-data-void>
        </div>
      </ng-template>
    </div>

    <div class="field col-12 d-flex w-full gap-2 align-items-center justify-content-end">
      <button pButton type="button" label="Adicionar Estudante" class="search-btn" (click)="addStudent()"></button>
    </div>

    <div class="field col-12">
      <p-table [value]="students" class="p-datatable-gridlines">
        <ng-template pTemplate="header">
          <tr>
            <th>#</th>
            <th>Nome</th>
            <th>Curso</th>
            <th>Ano/Freq.</th>
            <th>Valor</th>
            <th>Acções</th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-student let-i="rowIndex">
          <tr>
            <td>{{ i + 1 }}</td>
            <td>{{ student.nome }}</td>
            <td>{{ student.curso }}</td>
            <td>{{ student.anoFrequencia }}º</td>
            <td>{{ student.valor }}</td>
            <td>
              <button type="button" pButton icon="pi pi-trash" class="p-button-text p-button-danger"
                (click)="removeStudent(i)"></button>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="emptymessage">
          <tr>
            <td colspan="6" class="text-center">Sem estudantes selecionados</td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</form>
<p-confirmDialog></p-confirmDialog>
